import { TOPLoggedError } from 'constants/Errors';
import { HandlePredictionsDetailsType, HandleQueryChangeType, HandleSearchPredictionsType } from './types';

const handleSearchPredictions = async ({
  getAutoCompletePredictions,
  setLoadingPredictions,
  setPredictions,
  value,
}: HandleSearchPredictionsType) => {
  if (value.length > 0) {
    const predictionList = await getAutoCompletePredictions(value);
    setPredictions(predictionList);
  }
  setLoadingPredictions(false);
};

export const handleQueryChange = ({
  debounceHandler,
  event,
  getAutoCompletePredictions,
  onQueryChange,
  setDebounceHandler,
  setLoadingPredictions,
  setPredictions,
  setQuery,
}: HandleQueryChangeType) => {
  setQuery(event.target.value);

  if (onQueryChange) {
    onQueryChange(event.target.value);
  }

  if (event.target.value) {
    if (debounceHandler) {
      clearTimeout(debounceHandler);
    }
    setLoadingPredictions(true);
    const handler = setTimeout(() => {
      handleSearchPredictions({
        getAutoCompletePredictions,
        setLoadingPredictions,
        setPredictions,
        value: event.target.value,
      });
    }, 1000);
    setDebounceHandler(handler);
  }
};

export const handlePredictionsDetails = async ({
  getPlaceDetails,
  onAddressObjectChange,
  onQueryChange,
  prediction,
  setFocused,
  setPredictions,
  setQuery,
}: HandlePredictionsDetailsType) => {
  try {
    setFocused(false);
    const placeDetails = await getPlaceDetails(prediction.place_id);
    setQuery(placeDetails.formatted_address);
    if (onQueryChange) {
      onQueryChange(placeDetails.formatted_address);
    }
    setPredictions([prediction]);
    onAddressObjectChange(placeDetails);
  } catch (error) {
    new TOPLoggedError(`There was an error getting address predictions. Please try inputting another address.`, {
      endpoint: 'AddressInput/handlePredictionsDetails',
      cause: error,
    });
  }
};
